import { useState } from "react";
import Header from "../../shared/components/Header";
import NavigationDrawer, { type NavItem } from "../../shared/components/NavigationDrawer";
import { useTheme } from "@mui/material";

interface LayoutProps {
    children: React.ReactNode;
    items: NavItem[];
}

const Layout: React.FC<LayoutProps> = ({ children, items }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const theme = useTheme();

    const toggleSidebar = () => {
        setSidebarOpen((prev) => !prev);
    };

    return (
        <div className="h-screen w-full overflow-x-hidden flex flex-col">
            <Header onToggleSidebar={toggleSidebar} />
            <NavigationDrawer
                open={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                items={items}
            />
            <main
                className="flex-1 min-w-0 overflow-y-auto"
                style={{ backgroundColor: theme.palette.background.main }}
            >
                {children}
            </main>
        </div>
    );
}

export default Layout;